import { render, staticRenderFns } from "./CustomBaseInfo.vue?vue&type=template&id=4901861a&"
import script from "./CustomBaseInfo.vue?vue&type=script&lang=js&"
export * from "./CustomBaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports